import { createFileRoute, redirect } from '@tanstack/react-router'
import { MovementsScreen } from '@/features/inventory-movements/movements-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/movements')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock.view')) throw redirect({ to: '/' })
  },
  component: MovementsScreen,
})
